import { InjectionToken, Type } from '@angular/core';
import { LexplusBenutzerDetailDto } from '@lexplus-authentication-api';

/** The inputs a component passed as {@link MEIN_PROFIL_PERSONAL_EXTRA_ROWS} receives. */
export interface MeinProfilPersonalExtraRowsInputs {
  readonly details: LexplusBenutzerDetailDto;
}

/**
 * Rows an app adds below the language row of «Persönliche Angaben», for what only that app knows
 * about a user — the user app lists the user's Funktionen there. Optional: without it the tab ends
 * at the language.
 */
export const MEIN_PROFIL_PERSONAL_EXTRA_ROWS = new InjectionToken<Type<unknown>>('MEIN_PROFIL_PERSONAL_EXTRA_ROWS');
